import { Component, Input, inject } from '@angular/core';
import { AssetDto, GalleryDto } from '@picflow/types';
import { StateService } from '../../../services/state.service';
import { SmoothCounterComponent } from '../../../shared/components/smooth-counter/smooth-counter.component';
import { SvgComponent } from '../../../shared/components/svg/svg.component';

@Component({
  selector: 'app-activity-badge',
  templateUrl: './activity-badge.component.html',
  styleUrls: ['./activity-badge.component.scss'],
  standalone: true,
  imports: [SvgComponent, SmoothCounterComponent],
})
export class ActivityBadgeComponent {
  @Input() hasLink = false;
  @Input() onlyDot = false;
  @Input() hideWhenEmpty: boolean;
  @Input() color: string;
  @Input() asset: AssetDto;
  @Input() gallery: GalleryDto;
  @Input() subGalleries: GalleryDto[];
  @Input() hideBolt: boolean;
  @Input() noBorder: boolean;
  @Input() customBorderColor: string;

  private state = inject(StateService);

  public get unreadCount() {
    return Math.max(0, this._unreadCount);
  }

  private get _unreadCount() {
    if (this.asset) {
      return this.state.unseenActivityCountMap.get(this.asset.id);
    } else if (this.gallery) {
      if (!this.subGalleries) return this.state.unseenActivityCountMap.get(this.gallery.id);
      let total = this.state.unseenActivityCountMap.get(this.gallery.id);
      this.subGalleries.forEach(g => {
        total += this.state.unseenActivityCountMap.get(g.id);
      });
      return total;
    }
    return this.state.unseenActivity;
  }
}
